import { notifications } from '@mantine/notifications';
import { XIcon } from '@phosphor-icons/react';
import axios from 'axios';
import { get } from 'lodash';
import store from 'store2';

axios.defaults.baseURL = import.meta.env.VITE_API;

axios.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = store.get('i18nextLng', 'zh');

    return config;
});

axios.interceptors.response.use(
    (res) => {
        if (res.data.code !== 0) {
            notifications.show({
                autoClose: 3000,
                color: 'red',
                icon: <XIcon size={20} />,
                message: res.data.msg,
                position: 'top-center',
                withCloseButton: false,
            });

            return Promise.reject(new Error(res.data.msg));
        }

        return res;
    },
    (err) => {
        notifications.show({
            autoClose: 3000,
            color: 'red',
            icon: <XIcon size={20} />,
            message: get(err, 'response.data.msg', err.message),
            position: 'top-center',
            withCloseButton: false,
        });

        return Promise.reject(err);
    },
);

export default axios;
